import { render, staticRenderFns } from "./statisticsSales.vue?vue&type=template&id=5ee771c0&scoped=true&"
import script from "./statisticsSales.vue?vue&type=script&lang=js&"
export * from "./statisticsSales.vue?vue&type=script&lang=js&"
import style0 from "./statisticsSales.vue?vue&type=style&index=0&id=5ee771c0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee771c0",
  null
  
)

export default component.exports